import
  React
from 'react';

import 
  PropTypes
from 'prop-types'

import
  WithPopup
from 'src/HOC/WithPopup/WithPopup';

import
  BlueInfoIcon
from 'src/Components/Common/Svg/BlueInfoIcon';

import {
  isMobileView
} from 'src/Utility/utility';

import './VPPPopup.css';

const VPPPopup = (props) => {

  const {
    title,
    subtitle,
    detailsHeading,
    details
  } = props.terms

  const contentStyleDesktop = {
    position: 'absolute',
    margin: 'auto',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%',
    padding: '0px'
  }

  const contentStyleMobile = {
    margin: 'auto',
  }

  return (

    <div>
  
      { props.showVPPPopup &&

        <WithPopup
          contentStyle={isMobileView() ? contentStyleMobile : contentStyleDesktop}>

          <div 
            className="vpp-screen-wrapper">

            <button 
              onClick={props.close} 
              className="vpp-screen-close-button">
              x
            </button>

            <div className="vpp-screen-main-section">

              <div className="vpp-screen-text-section">

                <BlueInfoIcon />

                <div className="vpp-screen-title">{ title }</div>

                <div className="vpp-screen-subtitle">{ subtitle }</div>

                <div className="vpp-screen-details-container">

                  <div className="vpp-screen-details-heading">{ detailsHeading }</div>

                  <ol className='vpp-screen-list-details'>

                    { details.map((detail, index) => (

                      <li className='vpp-screen-details' key={index}>

                        {detail}
                      </li>
                    ))
                    }
                  </ol>
                </div>
              </div>
            </div>

            <button
              className='vpp-screen-footer-btn'
              onClick={ props.onClick }>

              { props.buttonText }
            </button>
          </div>

        </WithPopup>
      }
    </div>

  )
}

VPPPopup.propTypes = {
  terms: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    detailsHeading: PropTypes.string,
    details: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  showVPPPopup: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  buttonText: PropTypes.string,
};

export default VPPPopup;